<div class="section over-hide">
    <div class="section padding-top-120 padding-top-mob-nav section-background-rana">
        <div class="section-1400 pt-xl-4">
            <div class="container-fluid padding-top-40">
                <div class="row justify-content-center">
                    <H6>
                        <p>Gallery works!</p>
                    </H6>

                </div>
            </div>
        </div>
    </div>
</div>
